import { createFileRoute } from '@tanstack/react-router';
import { PeopleHeatmap } from '@/features/resources/heatmap/people-heatmap';
import { parseHeatmapSearch } from '@/features/resources/heatmap/heatmap-search';

/** People × weeks; raster, range, unit and filters live in the URL. */
export const Route = createFileRoute('/_app/resources/')({
  validateSearch: (raw: Record<string, unknown>) => parseHeatmapSearch(raw),
  component: RouteComponent,
});

function RouteComponent() {
  const search = Route.useSearch();
  const navigate = Route.useNavigate();
  return (
    <PeopleHeatmap
      search={search}
      onSearchChange={(next) => {
        void navigate({ search: next, replace: true });
      }}
    />
  );
}
